import React, { useEffect, useMemo } from "react";
import { IItemProps } from "devextreme-react/form";

import { PageProps, UpdateDomTitleForForm } from "@ezhou/core";
import { MainCard } from "@ezhou/app_mantis_1_1";

import { apiResourceGrantTypeOptions } from "../../model/constants/enums";
import { getUserProfileFromCache } from "../../services/userSettingService";

import { InactivatableCrudDataGrid } from "../common/InactivatableCrudDataGrid";

import { dummyRestfulApiResourceRow, restfulApiResourceColumns } from "./model/metaData";
import { RestfulApiScopes } from "./RestfulApiScopes";

const RestfulApiResources = (pageProps: PageProps) => {
  const logger = pageProps.loggerProvider.getLogger("RestfulApiResources");

  useEffect(() => {
    UpdateDomTitleForForm(pageProps);
  });

  const editorItemOptions = useMemo(() => new Map<string, IItemProps>([
    [
      "grantType",
      {
        editorType: "dxSelectBox",
        editorOptions: {
          dataSource: apiResourceGrantTypeOptions,
          searchEnabled: true,
          placeholder: "Select a grant type",
        },
      },
    ],
    [
      "needAuthentication",
      {
        editorType: "dxCheckBox",
      },
    ],
    [
      "active",
      {
        editorType: "dxCheckBox",
      },
    ],
  ]), []);

  const organizationId = getUserProfileFromCache(pageProps.dataStore).defaultOrganization;
  const detailComponent = (props: any) => {
    return (
      <RestfulApiScopes
        parentKey={{
          organizationId: organizationId,
          resourceName: props.data.data.name,
        }}
        pageProps={pageProps}
        logger={logger}
      />
    );
  };

  return (
    <MainCard title="API Resources">
      <InactivatableCrudDataGrid
        pageProps={pageProps}
        logger={logger}
        dummyRow={dummyRestfulApiResourceRow}
        baseUrl="restful-resources"
        isOrganizationData={true}
        keyExpr="name"
        formTitle="Restful API Resource"
        formColCount={2}
        formColSpan={2}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
        columnConfigs={restfulApiResourceColumns}
        masterDetailComponent={detailComponent}
        editorItemOptions={editorItemOptions}
      ></InactivatableCrudDataGrid>
    </MainCard>
  );
};

export default RestfulApiResources;
